import { Dispatch, FC, SetStateAction } from "react";
import { Checkbox } from "./ui/checkbox";
import { cn } from "@/utils/utils";
import GoodStar from "../../TDD-Images/good-star.png";
import BadStar from "../../TDD-Images/bad-star.png";
import { getLabel } from "@/utils/utils";
import TrackQuestionDropDown from "./TrackQuestionDropDown";
import { ITrackQuestion, Question } from "@/utils/types";
import { isQuestionInSelected } from "@/utils/utils";
import { options } from "./TrackDifficultyFilter";

interface Props {
  question: ITrackQuestion;
  setSelectedQuestions: Dispatch<SetStateAction<Question[]>>;
  showCheckbox: boolean;
  dropDownOptions?: { label: string;  parent: string; value: string; noOfStars: number }[];
  navigate?: (parent:string, value: string) => void;
}

const TrackSessionQuestion: FC<Props> = ({
  question,
  setSelectedQuestions,
  showCheckbox,
  dropDownOptions,
  navigate,
}) => {
  return (
    <div className="flex w-full justify-center items-center gap-3 cursor-pointer text-left">
      <div
        className="flex w-full justify-center items-center gap-3 cursor-pointer text-left"
        onClick={() =>
          setSelectedQuestions((s) =>
            isQuestionInSelected(question.question, s)
              ? s.filter((q) => q.question !== question.question.question)
              : [...s, question.question]
          )
        }
      >
        {showCheckbox && (
          <Checkbox
            className="shadow-none border-[#363F72]"
            checked={question.selected}
          />
        )}
        <div className="w-full border py-2 px-4 border-[#D5D9EB] text-[14px] rounded-md bg-[#FAFAFA] flex justify-between items-center">
          <p className="m-0 p-0 w-[85%]">{question.question.question}</p>
          <div className="flex gap-4 justify-center items-center">
            <div
              className={cn(
                "border px-2 py-1 rounded-md justify-center items-center text-nowrap",
                question.tagColor
              )}
            >
              <p className="m-0 p-0">{getLabel(question.tag)}</p>
            </div>
            <div className="flex gap-2 justify-center items-center">
              <p
                className={cn(
                  "p-0 m-0 text-[22px]",
                  options.filter((x) => x.label === question.difficulty)[0]
                    ?.color || "text-gray"
                )}
              >
                •
              </p>
              <p
                className={cn(
                  "p-0 m-0",
                  options.filter((x) => x.label === question.difficulty)[0]
                    ?.color || "text-gray"
                )}
              >
                {question.difficulty}
              </p>
            </div>
            <div className="flex justify-center items-center">
              <img
                src={question.noOfStars >= 1 ? GoodStar : BadStar}
                alt="star"
                className="w-[27px] object-contain"
              />
              <img
                src={question.noOfStars >= 2 ? GoodStar : BadStar}
                alt="star"
                className="w-[27px] object-contain"
              />
              <img
                src={question.noOfStars >= 3 ? GoodStar : BadStar}
                alt="star"
                className="w-[27px] object-contain"
              />
            </div>
          </div>
        </div>
      </div>
      {dropDownOptions && (
        <TrackQuestionDropDown options={dropDownOptions} navigate={(e:string, i:string)=>navigate!(e,i)} />
      )}
    </div>
  );
};

export default TrackSessionQuestion;
